import { render, staticRenderFns } from "./AddNewLocationForm.vue?vue&type=template&id=693a36d6"
import script from "./AddNewLocationForm.vue?vue&type=script&lang=js"
export * from "./AddNewLocationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports